module.exports = __webpack_public_path__ + "images/erp-nation-glad-title.1790731042052.png";